/* Mapping flag for currency icon from label */
export const flagCurrenciesIconMapper = currencyName => {
    const flagsIcons = {
        AKZ: 'AKZ-flag',
        EUR: 'EUR-flag',
        USD: 'USD-flag',
        AED: 'AED-flag',
        CAD: 'CAD-flag',
        CHF: 'CHF-flag',
        CNY: 'CNY-flag',
        DKK: 'DKK-flag',
        GBP: 'GBP-flag',
        JPY: 'JPY-flag',
        MZN: 'MZN-flag',
        NAD: 'NAD-flag',
        NOK: 'NOK-flag',
        SEK: 'SEK-flag',
        XAF: 'XAF-flag',
        ZAR: 'ZAR-flag'
        // TODO ADD undefined: flag (?)
    }

    return flagsIcons[currencyName]
}
